function initStyles() {
    let styleImport = () => import("styles/app.scss");
    const festivalImport = {
        "aarhundredets-festival": () => import("styles/aa.scss"),
        "hearts-minds": () => import("styles/hm.scss"),
        "park": () => import("styles/park.scss")
    };

    const cls = Array.from(document.body.classList);
    const importMethod = Object.entries(festivalImport).find(([key]) => cls.includes(key));
    if (importMethod) styleImport = importMethod[1];

    styleImport();
}

initStyles();